module.exports = __webpack_public_path__ + "img/project_e2.168cbeca.jpg";